<div class="members-format-container">
  <div class="d-flex flex-column gap-2">
    <span class="members-format-title" i18n>Formatting Requirements</span>
    <span class="members-format-subtitle" i18n>
      The following formatting requirements must be followed for a successful file upload:
    </span>
  </div>
  <div class="d-flex flex-column gap-3">
    <div class="members-format-rule-container">
      <span class="members-format-rule" i18n>1. The following fields are required for each row:</span>
      <ul>
        <li i18n>Last Name</li>
        <li i18n>First Name</li>
        <li i18n>Date of Birth</li>
        <li i18n>SIN</li>
        <li i18n>Email</li>
        <li i18n>Employment Start</li>
        <li i18n>Employment Type</li>
        <li i18n>Province of Employment</li>
        <li i18n>Work from Home</li>
        <li i18n>Contribution Start</li>
      </ul>
    </div>
    <div class="members-format-rule-container">
      <span class="members-format-rule" i18n>
        2. Date of Birth, Employment Start, and Contribution Start must use one of the accepted formats:
      </span>
      <ul>
        <li i18n>January 8, 1990</li>
        <li i18n>Jan 8, 1990</li>
        <li i18n>08-01-1990 (DD-MM-YYYY)</li>
        <li i18n>08011990 (DDMMYYYY)</li>
      </ul>
    </div>
    <div class="members-format-rule-container">
      <span class="members-format-rule" i18n> 3. The following columns must contain only numeric values: </span>
      <ul>
        <li i18n>SIN</li>
      </ul>
    </div>
    <div class="members-format-rule-container">
      <span class="members-format-rule" i18n>
        4. Employment Type must be provided with one of the following abbreviations:
      </span>
      <ul>
        <li i18n>FT = Full Time</li>
        <li i18n>PT = Part Time / Less Than Full Time</li>
      </ul>
    </div>
    <div class="members-format-rule-container">
      <span class="members-format-rule" i18n> 5. Province of Employment must use a two character abbreviation: </span>
      <ul>
        <li i18n>Saskatchewan = SK</li>
        <li i18n>Northwest Territories = NT</li>
        <li i18n>Newfoundland & Labrador = NL</li>
      </ul>
    </div>
    <div class="members-format-rule-container">
      <span class="members-format-rule" i18n> 6. Work from Home must be provided as one single letter: </span>
      <ul>
        <li i18n>Y = Yes</li>
        <li i18n>N = No</li>
      </ul>
    </div>
  </div>
</div>
